<template>
	<div class="body-mid" v-if="loading">
		<div style="background: #E5EDFB;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				个人简历
			</div>
		</div>
		<div class="form">
			<div class="form-item">
				<div class="title">
					<div><span style="color:red;">*</span>姓名</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入姓名" v-model="serveData.name">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div width='200px'>身份</div>
					<span>:</span>
				</div>
				<div class="inp">
					<el-select v-model="serveData.record" placeholder="请选择您的身份">
						<el-option v-for="item in IDoptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>证件号</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入证件号码" v-model="serveData.id_card_num">
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>学位</div>
					<span>:</span>
				</div>
				<div class="inp">
					<el-select v-model="serveData.qualification" placeholder="请选择您的学位">
						<el-option v-for="item in XWoptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>职称 </div>
					<span>:</span>
				</div>
				<div class="inp">
					<el-select v-model="serveData.job_title" placeholder="请选择您的职称">
						<el-option v-for="item in ZCoptions" :key="item.value" :label="item.label" :value="item.label">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="form-item">
				<div class="title">
					<div>行政职务</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入您的行政职务" v-model="serveData.duty">
				</div>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div><span style="color:red;">*</span>单位</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入您的单位" v-model="serveData.company">
					<div v-for="(item,index) in serveData.company_extra" :key="index">

						<input type="text" placeholder="请输入您的单位" v-model="serveData.company_extra[index]">
					</div>
					<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;">
						<div class="puls" @click="dialogVisible1 = true">+</div>
						<span style="margin-left: 8px;">补充单位</span>
					</div>
				</div>
			</div>
			<el-dialog title="添加单位" center :visible.sync="dialogVisible1" width="500px">
				<div style=" margin-bottom: 30px;width:500px;">
					<el-input style="font-size: 20px;" placeholder="请输单位名称" v-model="dwAdd"> </el-input>
				</div>
			
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible1 = false">取 消</el-button>
					<el-button type="primary" @click="confrimAddDw">确 定</el-button>
				</span>
			</el-dialog>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div><span style="color:red;">*</span>邮箱</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入您的邮箱" v-model="serveData.email">
					<div v-for="(item,index) in serveData.email_extra">
						<input type="text" placeholder="请输入您的邮箱" v-model="serveData.email_extra[index]">
					</div>
					<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;"
						>
						<div class="puls" @click="dialogVisible2 = true">+</div>
						<span style="margin-left: 8px;">补充邮箱</span>
					</div>
				</div>
			</div>
			<el-dialog title="补充邮箱" center :visible.sync="dialogVisible2" width="500px">
				<div style=" margin-bottom: 30px;width:500px;">
					<el-input style="font-size: 20px;" placeholder="请输邮箱号" v-model="emailAdd"> </el-input>
				</div>
			
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible2 = false">取 消</el-button>
					<el-button type="primary" @click="confrimAddEmail">确 定</el-button>
				</span>
			</el-dialog>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div><span style="color:red;">*</span>电话</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入您的电话" v-model="serveData.phone">
					<div v-for="(item,index) in serveData.phone_extra">
						<input type="text" placeholder="请输入您的电话" v-model="serveData.phone_extra[index]">
					</div>
					<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;"
						>
						<div class="puls" @click="dialogVisible3 = true">+</div>
						<span style="margin-left: 8px;">补充手机号</span>
					</div>
				</div>
			</div>
			<el-dialog title="补充电话" center :visible.sync="dialogVisible3" width="500px">
				<div style=" margin-bottom: 30px;width:500px;">
					<el-input style="font-size: 20px;" placeholder="请输电话号" v-model="phoneAdd"> </el-input>
				</div>
			
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible3 = false">取 消</el-button>
					<el-button type="primary" @click="confrimAddPhone">确 定</el-button>
				</span>
			</el-dialog>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div>行业领域 </div>
					<span>:</span>
				</div>
				<div class="inp">
					<!-- <el-select v-model="serveData.industry_ids[0]" placeholder="请选择您的行业领域">
						<el-option v-for="item in HangYe" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select> -->
					<div v-for="(item,index) in serveData.industry_ids">
						<el-select v-model="serveData.industry_ids[index]" placeholder="请选择您的行业领域">
							<el-option v-for="item in  HangYe" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
						</el-select>
					</div>
					<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;"
						@click="dialogVisible4 = true">
						<div class="puls">+</div>
						<span style="margin-left: 8px;">补充行业领域</span>
					</div>
				</div>
			</div>
			<el-dialog title="补充行业领域" center :visible.sync="dialogVisible4" width="500px">
				<div style=" margin-bottom: 30px;width:500px;">
					<el-select v-model="HYLY" placeholder="请选择您的行业领域">
						<el-option v-for="item in  HangYe" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>
			
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible4 = false">取 消</el-button>
					<el-button type="primary" @click="confrimAddHY">确 定</el-button>
				</span>
			</el-dialog>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div>兴趣方向</div>
					<span>:</span>
				</div>
				<div class="inp">
					<input type="text" placeholder="请输入您的兴趣方向" v-model="serveData.interest">
					<div v-for="(item,index) in serveData.interest_extra">
						<input type="text" placeholder="请输入您的兴趣方向" v-model="serveData.interest_extra[index]">
					</div>
					<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;"
						>
						<div class="puls" @click="dialogVisible5 = true">+</div>
						<span style="margin-left: 8px;">补充兴趣方向</span>
					</div>
				</div>
			</div>
			<el-dialog title="补充兴趣方向" center :visible.sync="dialogVisible5" width="500px">
				<div style=" margin-bottom: 30px;width:500px;">
					<el-input style="font-size: 20px;" placeholder="请输入您的兴趣方向" v-model="hobbyAdd"> </el-input>
				</div>
			
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible5 = false">取 消</el-button>
					<el-button type="primary" @click="confrimAddHobby">确 定</el-button>
				</span>
			</el-dialog>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div>补充添加</div>
					<span>:</span>
				</div>
				<div class="inp">
					<div style="display: flex;">
						<input type="text" placeholder="请输入您补充的链接" v-model="serveData.supplement.link">
						<div style="margin-left: 30px;">
							<span>备注:</span>
							<input type="text" style="width: 350px;margin-left: 10px;" placeholder="请输入您补充的信息" v-model="serveData.supplement.remark">
						</div>
					</div>
					<div>
						<div v-for="(item,index) in serveData.supplement_extra" style="display: flex;">
							<input type="text" placeholder="请输入您补充的链接" v-model="item.link">
							<div style="margin-left: 30px;">
								<span>备注:</span>
								<input type="text" style="width: 350px;margin-left: 10px;" placeholder="请输入您补充的信息" v-model="item.remark">
							</div>
						</div>
					</div>
					<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;"
						>
						<div class="puls" @click="dialogVisible6 = true">+</div>
						<span style="margin-left: 8px;">增加</span>
					</div>
				</div>
			</div>
			<el-dialog title="补充兴趣方向" center :visible.sync="dialogVisible6" width="500px">
				<div style=" margin-bottom: 30px;width:500px;">
					<el-input style="font-size: 20px;margin-bottom: 25px;" placeholder="请输入您补充的链接" v-model="linkInfo.link"> </el-input>
					<el-input style="font-size: 20px;" placeholder="请输入您补充的信息" v-model="linkInfo.remark"> </el-input>
				</div>
			
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible6 = false">取 消</el-button>
					<el-button type="primary" @click="confrimAddLink">确 定</el-button>
				</span>
			</el-dialog>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 45px;">
					<div>证书</div>
					<span>:</span>
				</div>
				<div class="inp">
					<!-- //certificate_images -->
					<div style="display: flex;">
						<el-upload class="upload-demo" multiple
							:file-list="fileList" :on-remove='removeFile' :on-preview='previewFile' :headers='{token:$store.state.userInfo.token}'
							:action="uploadPath+'common/upload'"  :on-success='uploadAvatar'
							>
							<div
								style="color: black;line-height: 40px; width: 400px;height: 40px;background: #EEEEEE;border: 1px solid #EEEEEE;">
								点击上传
							</div>
						</el-upload>
					</div>
				</div>
			</div>

			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 40px;">
					<div>接包项目</div>
					<span>:</span>
				</div>
				<div class="inp">

					<div v-for="(item,index) in serveData.bid_ids_lists"
						style="height: 40px;margin-bottom: 20px;line-height: 40px;font-size: 18px;display: flex;align-items: center;">
						<span
							style="display: inline-block; width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
							{{item.title}}</span>
						<span style="margin-left: 10px; color: red;cursor: pointer;" @click="delxm(1,item.id)">删除</span>
					</div>

					<div style="display: flex; height: 40px;align-items: center;">
						<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;"
							>
							<div class="puls" @click="dialogVisible7 = true">+</div>
							<span style="margin-left: 8px;">增加</span>
						</div>
					</div>
				</div>
				<el-dialog title="添加接包项目" center :visible.sync="dialogVisible7" width="500px">
					<el-select v-model="jbValue" placeholder="请选择您的行业领域">
						<el-option v-for="item in  jbList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible7 = false">取 消</el-button>
						<el-button type="primary" @click="jbconfirm">确 定</el-button>
					</span>
				</el-dialog>
			</div>
			<div class="form-item" style="align-items: flex-start;">
				<div class="title" style="line-height: 40px;">
					<div>发包项目</div>
					<span>:</span>
				</div>
				<div class="inp">

					<div v-for="(item,index) in serveData.call_for_bid_ids_lists"
						style="height: 40px;margin-bottom: 20px;line-height: 40px;font-size: 18px;display: flex;align-items: center;">
						<span
							style="display: inline-block; width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
							{{item.title}}</span>
						<span style="margin-left: 10px; color: red;cursor: pointer;" @click="delxm(2,item.id)">删除</span>
					</div>

					<div style="display: flex; height: 40px;align-items: center;">
						<div style="margin-top: 0;display: flex;align-items: center;color: #0052D9;"
							>
							<div class="puls" @click="dialogVisible8 = true">+</div>
							<span style="margin-left: 8px;">增加</span>
						</div>
					</div>
				</div>
				<el-dialog title="添加接包项目" center :visible.sync="dialogVisible8" width="500px">
					<el-select v-model="fbValue" placeholder="请选择您的行业领域">
						<el-option v-for="item in  fbList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible8 = false">取 消</el-button>
						<el-button type="primary" @click="jbconfirm2">确 定</el-button>
					</span>
				</el-dialog>
			</div>
		</div>
		<div class="commit" @click="changgeResume">确认提交</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dwAdd:'',
				emailAdd:'',
				phoneAdd:'',
				HYLY:'',
				jbValue:'',
				fbValue:'',
				linkInfo:{
					remark:'',
					link:''
				},
				hobbyAdd:'',
				IDoptions: [{
					value: '选项1',
					label: '身份证'
				}, {
					value: '选项2',
					label: '通行证'
				},
				{
					value: '选项3',
					label: '台胞证'
				}, {
					value: '选项4',
					label: '护照'
				}
				],
				IDvalue: '',
				id_card_num: '',
				XWoptions: [{
					value: '选项1',
					label: '大专'
				}, {
					value: '选项2',
					label: '本科'
				}, {
					value: '选项3',
					label: '研究生'
				}, {
					value: '选项4',
					label: '博士'
				},
				{
					value: '选项5',
					label: '院士'
				}
				],
				XWvalue: '',
				ZCoptions: [{
					value: '选项1',
					label: '初级'
				}, {
					value: '选项2',
					label: '中级'
				},{
					value: '选项3',
					label: '高级'
				}
				],
				ZCvalue: '',
				form: {
					DWvalue: [{
						value: ''
					}],
					phoneValue: [{
						value: ''
					}],
					emailValue: [{
						value: ''
					}],
					hobbyValue: [{
						value: ''
					}],
					HYvalue: [{
						value: ''
					}],
					BCvalue: [{
						value: '',
						info: ''
					}],
					JBvalue: [],
					FBvalue: [],
				},
				fileList: [],
				dialogVisible: false,
				dialogVisible1: false,
				dialogVisible2: false,
				dialogVisible3: false,
				dialogVisible4: false,
				dialogVisible5: false,
				dialogVisible6: false,
				dialogVisible7: false,
				dialogVisible8: false,
				JBXM: {
					jbtitle: '',
					jbtextarea: ''
				},
				FBXM: {
					title: '',
					textarea: ''
				},
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				value: '',
				serveData: {},
				loading:false,
				HangYe:[],
				jbList:[],
				fbList:[],
				originData:{},
				transData:{}
			}
		},
		created() {
			this.getUserResume()
			this.getHangYe()
			// const ad = JSON.stringify(this.form)
			// console.log(ad);
		},
		methods: {
			// userChangeResume
			async changgeResume(){
				this.transData={...this.serveData}
				this.arrayDataToString('company_extra')
				this.arrayDataToString('email_extra')
				this.arrayDataToString('phone_extra')
				this.arrayDataToString('interest_extra')
				this.arrayDataToString('bid_ids')
				this.arrayDataToString('call_for_bid_ids')
				// this.arrayDataToString('industry_extra_ids')
				this.transData.supplement_extra = JSON.stringify(this.serveData.supplement_extra)
				this.transData.supplement = JSON.stringify(this.serveData.supplement)
				// transData.company_extra = this.serveData.company_extra.join(',')
				// transData.email_extra = this.serveData.email_extra.join(',')
				// transData.phone_extra = this.serveData.phone_extra.join(',')
				// transData.interest_extra = this.serveData.interest_extra.join(',')
				// transData.bid_ids = this.serveData.bid_ids.join(',')
				// transData.call_for_bid_ids = this.serveData.call_for_bid_ids.join(',')
				// this.transData.certificate_images = this.fileList.certificate_images
				
				console.log(this.transData,'resume');
				const resume = await this.$api.userChangeResume({...this.transData})
				if(resume.code == 1){
					this.$message({
						message:resume.msg,
						type:'success'
					})
				}else{
					this.$message({
						message:resume.msg,
						type:'warning'
					})
				}
			},
			arrayDataToString(data){
				if(this.serveData[data] != '' & this.serveData[data] != null){
					this.transData[data] = this.serveData[data].join(',')
				}else{
					this.transData[data] = ''
				}
			},
			async getUserResume() {
				const resume = await this.$api.userResume()
				this.serveData = resume.data
				this.originData = resume.data
				this.getJieBao()
				this.loading = true
				this.stringDataToArr('company_extra')
				this.stringDataToArr('email_extra')
				this.stringDataToArr('phone_extra')
				this.stringDataToArr('interest_extra')
				this.stringDataToArr('bid_ids')
				this.stringDataToArr('call_for_bid_ids')
				// this.stringDataToArr('supplement_extra')
				if(this.serveData.industry_ids.length == 0){
					this.serveData.industry_ids.push(null)
				}
				if(resume.data.supplement == null){
					this.serveData.supplement = {link:'',remark:''}
				}
				
				console.log(this.serveData.industry_ids,'2131231');
				if(resume.data.certificate_images_array != [] & resume.data.certificate_images_array != null){
					this.fileList = resume.data.certificate_images_array.map((item)=>{
						let obj = {}
						obj.name = item.filename
						obj.url = item.url
						console.log(obj);
						return obj
					})
				}
				
			},
			stringDataToArr(data){
				if(this.originData[data] != '' & this.originData[data] != null){
					console.log(this.originData[data]);
					this.serveData[data] = this.originData[data].split(',')
				}else{
					this.serveData[data] = []
				}
			},
			async getHangYe(){
				const list =await this.$api.getHangYeLists()
				this.HangYe = list.data
				console.log(list);
			},
			uploadAvatar(xhr, file, fileList){
				if(file.response.code == 1){
					this.$message({
						message:file.response.msg,
						type:'success'
					})
					const obj = {
						name:file.name,
						url:file.response.data.url,
						uid:file.uid,
						status:file.status
					}
					this.fileList.push(obj)
					const paths = this.fileList.map(item=> item.url)
					this.serveData.certificate_images = paths.join(',')
				}else{
					this.$message({
						message:file.response.msg,
						type:'warning'
					})
				}
				fileList = fileList.filter(item=> item.uid !== file.uid)
			},
			async getJieBao(){
				console.log('asdq3rqwe122');
				const jb = await this.$api.jiebaohuodongList({user_id:this.serveData.user_id})
				this.jbList = jb.data
				const fb = await this.$api.fabaohuodongList({user_id:this.serveData.user_id})
				this.fbList = fb.data
			},
			confrimAddLink(){
				if(this.linkInfo.link == '' || this.linkInfo.remark == ''){
					this.$message({
						message:'请输入完整信息',
						type:'warning'
					})
					return
				}else{
					this.serveData.supplement_extra.push({...this.linkInfo})
					this.dialogVisible6 = false
					this.linkInfo.link = ''
					this.linkInfo.remark = ''
				}
			},
			confrimAddHobby(){
					if(this.hobbyAdd == '' || this.hobbyAdd.length < 2){
						this.$message({
							message:'添加兴趣最少为两个字符',
							type:'warning'
						})
						return
					}else{
						this.serveData.interest_extra.push(this.hobbyAdd)
						this.hobbyAdd = ''
						this.dialogVisible5 = false
					}
			},
			confrimAddHY(){
				// console.log(typeof(this.serveData.industry_ids));
				this.serveData.industry_ids.push(this.HYLY)
				this.HYLY = ''
				this.dialogVisible4 = false
			},
			previewFile(e){
				console.log(e.url);
				const path = this.getImgSrc(e.url)
				window.open(path)
			},
			removeFile(e){
				// console.log(e,123);
				this.fileList = this.fileList.filter(item=> item.uid !== e.uid)
				const paths = this.fileList.map(item=> item.url)
				this.serveData.certificate_images = paths.join(',')
			},
			confrimAddPhone(){
				const phoneReg = /^1\d{10}$/;
				if(!phoneReg.test(this.phoneAdd)){
					this.$message({
						message:'手机号格式错误',
						type:'warning'
					})
					return
				}else{
					this.serveData.phone_extra.push(this.phoneAdd)
					this.phoneAdd = ''
					this.dialogVisible3 = false
				}
			},
			confrimAddEmail(){
				const emailReg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
				if(!emailReg.test(this.emailAdd)){
					this.$message({
						message:'邮箱格式错误',
						type:'warning'
					})
					return
				}else{
					this.serveData.email_extra.push(this.emailAdd)
					this.emailAdd = ''
					this.dialogVisible2 = false
				}
			},
			confrimAddDw(){
				if(this.dwAdd == '' || this.dwAdd.length < 2){
					this.$message({
						message:'添加单位最少为两个字符',
						type:'warning'
					})
					return
				}else{
					this.serveData.company_extra.push(this.dwAdd)
					this.dwAdd = ''
					this.dialogVisible1 = false
				}
			},
			delxm(e, index) {
				if (e == 1) {
					this.serveData.bid_ids_lists = this.serveData.bid_ids_lists.filter(item=> item.id != index)
					this.serveData.bid_ids = this.serveData.bid_ids.filter(item=> item != index)
					// this.serveData.bid_ids_lists.splice(index, 1)
				} else {
					this.serveData.call_for_bid_ids_lists = this.serveData.call_for_bid_ids_lists.filter(item=> item.id != index)
					this.serveData.call_for_bid_ids = this.serveData.call_for_bid_ids.filter(item=> item != index)
				}
			},
			jbconfirm() {
				if(!this.jbValue){
					this.dialogVisible7 = false
					return
				}
				const val = this.serveData.bid_ids_lists.find(item=>item.id == this.jbValue)
				console.log(val);
				if(val == undefined){
					this.serveData.bid_ids.push(this.jbValue)
					const data = this.jbList.find(item=>item.id == this.jbValue)
					this.serveData.bid_ids_lists.push(data)
					this.dialogVisible7 = false
				}else{
					this.$message({
						message:'已添加过该项目',
						type:'warning'
					})
				}
			},
			jbconfirm2() {
				if(!this.fbValue){
					this.dialogVisible8 = false
					return
				}
				const val = this.serveData.call_for_bid_ids_lists.find(item=>item.id == this.fbValue)
				console.log(val);
				if(val == undefined){
					this.serveData.call_for_bid_ids.push(this.fbValue)
					const data = this.fbList.find(item=>item.id == this.fbValue)
					this.serveData.call_for_bid_ids_lists.push(data)
					this.dialogVisible8 = false
				}else{
					this.$message({
						message:'已添加过该项目',
						type:'warning'
					})
				}
			},

		},

	}
</script>

<style scoped lang="less">
	.commit {
		width: 261px;
		height: 40px;
		background: #0052D9;
		color: white;
		font-size: 18px;
		font-weight: bold;
		cursor: pointer;
		line-height: 40px;
		margin: auto;
		text-align: center;
	}

	.puls {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		color: white;
		line-height: 20px;
		cursor: pointer;
		font-size: 20px;
		background: #0052D9;
		text-align: center;
	}

	.form {
		padding: 40px 50px;
		box-sizing: border-box;

		/deep/.el-select {
			margin-bottom: 20px;
		}

		/deep/.el-textarea__inner {
			border: 1px solid #D2D2D2;
			color: black !important;
			font-family: none;
		}

		/deep/.el-input__inner {
			width: 448px;
			border: 1px solid #D2D2D2;
			line-height: 45px;
			font-size: 18px;
			color: black !important;
			height: 45px;
			box-sizing: border-box;
		}

		/deep/.el-textarea__inner,
		/deep/.el-input__inner::placeholder {
			color: #999999;
			font-size: 18px;
		}

		.form-item {
			display: flex;
			margin-bottom: 30px;
			align-items: baseline;

			.inp {
				margin-left: 40px;

				& input {
					font-size: 18px;
					padding: 0 15px;
					box-sizing: border-box;
					width: 448px;
					height: 45px;
					border: 1px solid #D2D2D2;
					border-radius: 6px;
					margin-bottom: 20px;
				}
			}

			.title {
				font-size: 18px;
				display: flex;
				align-items: center;

				&>div {
					width: 77px;
					text-align-last: justify;
				}
			}
		}
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
		background: #fff;
	}
</style>